import { render, staticRenderFns } from "./BipRoadsModeling.vue?vue&type=template&id=03a5771f&scoped=true&"
import script from "./BipRoadsModeling.vue?vue&type=script&lang=js&"
export * from "./BipRoadsModeling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a5771f",
  null
  
)

export default component.exports